<template>
    <div 
            class="statistics-cell" 
            :class="{ selected: category === selectedCategory }" 
            @click.prevent="$emit('select', category)"
    >
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'touchpoint-statistics-overview-cell',
        props: {
            selectedCategory: {
                type: String,
                required: false
            },
            category: {
                type: String,
                required: true
            }
        }
    }
</script>